module.exports = __webpack_public_path__ + "img/41.6f1aeb1a.jpg";